function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const DollarIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11H13V6h4c.6 0 1-.4 1-1s-.4-1-1-1h-4V1c0-.6-.4-1-1-1s-1 .4-1 1v3H9.5C7 4 5 6 5 8.5S7 13 9.5 13H11v5H6c-.6 0-1 .4-1 1s.4 1 1 1h5v3c0 .6.4 1 1 1s1-.4 1-1v-3h1.5c2.5 0 4.5-2 4.5-4.5S17 11 14.5 11zm-5 0C8.1 11 7 9.9 7 8.5S8.1 6 9.5 6H11v5H9.5zm5 7H13v-5h1.5c1.4 0 2.5 1.1 2.5 2.5S15.9 18 14.5 18z"
  }));
};
export default DollarIcon;